"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { CircleCheck, Lightbulb } from "lucide-react";
export default function StormDamageInsuranceAssistance() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll();
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll();
  const {
    ref: tipsRef,
    isVisible: tipsVisible
  } = useRevealOnScroll();
  return <section data-section-id="257709" id="storm-damage-insurance-assistance" className="bg-background py-12 md:py-20">
      <div className="page-container">
        {}
        <div ref={headingRef} className={`mb-8 transition-all duration-1000 ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="font-default text-3xl md:text-4xl font-bold text-primary mb-6">
            Storm Damage & Insurance Assistance
          </h2>
        </div>

        {}
        <div ref={contentRef} className={`max-w-3xl transition-all duration-1000 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {}
          <p className="font-default text-base text-foreground/80 mb-6 leading-relaxed">
            Severe weather often leaves behind more than just visible debris. We identify damage you may have missed, such as hidden hail impacts and wind-weakened seals that standard adjusters often overlook. Our team acts quickly to secure your property, ensuring no further damage reaches your home's interior.
          </p>

          {}
          <p className="font-default text-base text-foreground/80 mb-8 leading-relaxed">
            We know that navigating insurance claims feels overwhelming when you're just trying to protect your family. We manage the entire partnership with your provider, we guide you through every step of the paperwork, and we ensure every bit of damage is documented with professional precision. We handle the technical stress so you can focus on getting your life back to normal.
          </p>

          {}
          <div ref={tipsRef} className={`mb-8 transition-all duration-1000 ${tipsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Card className="border-l-4 border-l-secondary bg-secondary/5 shadow-md rounded-md">
              <CardContent className="pt-6">
                <div className="flex gap-4">
                  <div className="flex-shrink-0 pt-0.5">
                    <CircleCheck className="size-5 text-secondary" />
                  </div>
                  <div>
                    <h3 className="font-default font-semibold text-primary mb-2">
                      Our Promise to You
                    </h3>
                    <p className="font-default text-lg italic text-primary leading-relaxed">
                      "Think of us as your neighbor who happens to be an expert. We'll stand by your side from the first inspection until the last shingle is placed, making sure your home is treated with the care it deserves."
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}